import * as React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

class FooterLoggedOut extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {

        const { helpDeskNumber, helpDeskEmail, helpDeskEmailText, applicationVersion, currentYear } = this.props;

        return (
            <div className="container-fluid footer-container footer-loggedout">
                <div className="row">
                    <div className="col-12 maxWidth-content">
                        <div className="row">
                            <div className="col-12 col-md-6 footer__links">
                                <div className="footer__help-links">
                                    <div className="help-title">Need Help?</div>
                                    <div className="help-email"><a href={"tel:" + helpDeskNumber}><span className="icon-phone" /> {helpDeskNumber}</a></div>
                                </div>
                            </div>
                            <div className="col-12 col-md-6 footer__copyright">
                                <div className="copyright">© {currentYear} All Rights Reserved</div>
                                {/*<div className="mychart-copyright">Version: {applicationVersion}</div>*/}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        helpDeskNumber: state.session.serverData ? state.session.serverData.helpDeskNumber : "",
        helpDeskEmail: state.session.serverData ? state.session.serverData.helpDeskEmail : "",
        helpDeskEmailText: state.session.serverData ? state.session.serverData.helpDeskEmailText : "",
        applicationVersion: state.session.serverData ? state.session.serverData.applicationVersion : "1.0.0.0",  // we'll default with rendering for mybswhealth
        currentYear: state.session.serverData && state.session.serverData.currentYear ? state.session.serverData.currentYear : "2022"
    };
};

export default connect(mapStateToProps)(FooterLoggedOut);
